import { createRouter, createWebHistory } from "vue-router";
import HomeGarantia from "@/views/HomeGarantia.vue"
import HomeProducto from "@/views/HomeProducto.vue"
import HomeOptico from "@/views/HomeOptico.vue"

const routes = [
    {
      path: "/",
      name: "home",
      component: HomeGarantia
    },
    {
      path: "/home",
      name: "optico",
      component: HomeOptico
    },
    {
      path: "/order",
      name: "producto",
      component: HomeProducto
    },
  ]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;